module.exports = __webpack_public_path__ + "img/etiquetado5.29a14a50.jpg";